import { ref } from 'vue'

const isLoading = ref(false)
const loadingMessage = ref('')
const loadingTimeout = ref(null)

export function useLoadingManager() {
  const startLoading = (message = 'Loading...') => {
    // Clear any existing timeout
    if (loadingTimeout.value) {
      clearTimeout(loadingTimeout.value)
    }

    isLoading.value = true
    loadingMessage.value = message
  }

  const stopLoading = () => {
    // Set a minimum display time for the loader
    loadingTimeout.value = setTimeout(() => {
      isLoading.value = false
      loadingMessage.value = ''
    }, 200) // Minimum 200ms display time
  }

  const forceStopLoading = () => {
    if (loadingTimeout.value) {
      clearTimeout(loadingTimeout.value)
    }
    isLoading.value = false
    loadingMessage.value = ''
  }

  return {
    isLoading,
    loadingMessage,
    startLoading,
    stopLoading,
    forceStopLoading
  }
}
